import request from '@/api/request'

export function saveTest1(data) {
    return request({
        url: '/model-analysis/detection/saveTest1',
        method: 'post',
        data,
    })
}
export function saveLine(data) {
    return request({
        url: '/model-analysis/detection/saveLine',
        method: 'post',
        data,
    })
}

export function fetchTestList(data) {
    return request({
        url: '/model-analysis/detection/testlist1',
        method: 'post',
        data,
    })
}
export function fetchTestItemList(data) {
    return request({
        url: '/model-analysis/detection/listTest',
        method: 'post',
        data,
    })
}

export function fetchDefectInfoList(data) {
    return request({
        url: '/model-analysis/detection/listDefectInfo',
        method: 'post',
        data,
    })
}

export function fetchDefectPipeList(data) {
    return request({
        url: '/model-analysis/detection/listDefectPipe',
        method: 'post',
        data,
    })
}

export function fetchDefectSerialList(data) {
    return request({
        url: '/model-analysis/detection/listDefectSerial',
        method: 'post',
        data,
    })
}

export function fetchDetail(data) {
    return request({
        url: `/model-analysis/detection/query/${data.id}/${data.type}`,
    })
}

export function saveTestItem(data) {
    return request({
        url: '/model-analysis/detection/saveTest',
        method: 'post',
        data,
    })
}

export function saveDefectInfo(data) {
    return request({
        url: '/model-analysis/detection/saveDefectInfo',
        method: 'post',
        data,
    })
}

export function saveDefectPipe(data) {
    return request({
        url: '/model-analysis/detection/saveDefectPipe',
        method: 'post',
        data,
    })
}
export function saveDefectSerial(data) {
    return request({
        url: '/model-analysis/detection/saveDefectSerial',
        method: 'post',
        data,
    })
}

export function editTestItem(data) {
    return request({
        url: '/model-analysis/detection/modifyTest',
        method: 'post',
        data,
    })
}

export function editTest(data) {
    return request({
        url: '/model-analysis/detection/modifyTest1',
        method: 'post',
        data,
    })
}

export function editDefectInfo(data) {
    return request({
        url: '/model-analysis/detection/modifyDefectInfo',
        method: 'post',
        data,
    })
}

export function editDefectPipe(data) {
    return request({
        url: '/model-analysis/detection/modifyDefectPipe',
        method: 'post',
        data,
    })
}

export function remove({ id, type }) {
    return request({
        url: '/model-analysis/detection/delete/' + id + '/' + type,
        method: 'post'
    })
}